/* jshint esversion: 6 */
/* jshint ignore:start */
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import { IoIosNotificationsOutline } from "react-icons/io";
import LodingLottie from '../Lodinglottie';
import PageHeader from './PageHeader';
import { FiBell } from 'react-icons/fi';

const NotificationShow = () => {
    const { t } = useTranslation();

    const { basUrl, setColor } = useContext(MyContext);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setColor("");
        const localData = localStorage.getItem("Register_User");
        if (localData) {
            const Id = JSON.parse(localData);
            axios.post(`${basUrl}u_notification_list`, { "uid": Id.id })
                .then((res) => {
                    setData(res.data.NotificationData || []);
                    setLoading(false);
                })
                .catch(() => {
                    setData([]);
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, [basUrl, setColor]);

    return (
        <div>
            <div className="bg-[#e5e5e5] main-wrapper-history min-h-screen">
                <div className="content-body">
                    <div className="container-fluid py-4 px-sm-4 px-3">
                        <PageHeader
                            title={t('Notification')}
                            subtitle={t('Stay updated with your latest account activities and matches')}
                            breadcrumbs={[{ label: t('Notification') }]}
                            icon={FiBell}
                        />
                        <div className="col-xl-12 z-[333]">
                            <div className="card card-rounded-1 bg-white p-4 rounded-2xl shadow-xs border border-gray-200/80">
                                {data.length > 0
                                    ? <div className="card-body p-0">
                                        <div className="flex flex-col gap-3">
                                            {data?.map((item, index) => (
                                                <div
                                                    className="w-full p-4 justify-between border border-gray-200 flex items-center rounded-2xl bg-gray-50/50 hover:bg-purple-50/30 transition-colors"
                                                    key={index}
                                                >
                                                    <div className="flex items-center gap-3 flex-1 min-w-0">
                                                        <div className="w-10 h-10 rounded-xl bg-purple-100 text-purple-600 flex items-center justify-center text-xl shrink-0">
                                                            <IoIosNotificationsOutline />
                                                        </div>
                                                        <div className="min-w-0 flex-1">
                                                            <h6 className="m-0 text-sm sm:text-base font-semibold text-gray-900 truncate">{item.title}</h6>
                                                            <p className="m-0 text-xs sm:text-sm text-gray-500 mt-1 line-clamp-2">{item.description}</p>
                                                        </div>
                                                    </div>
                                                    <span className="text-xs text-gray-400 font-medium shrink-0 ml-3">{item.datetime?.split(" ")[0]}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    : <div className="h-64 flex flex-col justify-center items-center text-center">
                                        <FiBell className="text-4xl text-gray-300 mb-2" />
                                        <h3 className="text-gray-500 font-medium text-base m-0">{t('No any Notification...')}</h3>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loading && (
                <div className="w-full h-screen bg-white fixed flex items-center justify-center top-0 left-0 right-0 bottom-0 z-[555]">
                    <LodingLottie ClassCss={"w-[20%] max-_430_:w-[100%] max-_770_:w-[50%] max-_1030_:w-[40%] max-_1145_:w-[30%] max-_1200_:w-[30%] max-_1300_:w-[30%]"} />
                </div>
            )}
        </div>
    );
};

export default NotificationShow;
/* jshint ignore:end */
